// extracted by mini-css-extract-plugin
module.exports = {"head":"page_head__8BeiJ","ItemList":"page_ItemList__2tl0t"};